export default {
  '(public).activities': 'Activities',
  '(public).activities.home': 'Activities',
  '(public).activities.detail': 'Activity Details',
  '(public).course': 'Course',
  '(public).course.home': 'Course',
  '(public).course.living-bar.detail': 'Course Details',
  '(public).course.video.detail': 'Video Details',
  '(public).course.video.play': 'Video Play',
  '(public).notifications': 'Notifications',
  '(public).notifications.home': 'Notifications',
  '(public).notifications.detail': 'Notification Details',
  '(public).share': 'Share',
  '(public).share.home': 'Share',
  '(public).share.detail': 'Share Details',
  '(public).work-orders': 'Work Orders',
  '(public).work-orders.home': 'Work Orders',
  '(public).work-orders.detail': 'Work Order Details',
  '(public).work-orders.create': 'Create Work Order',
  '(public).work-orders.reply': 'Reply Work Order',
}
